import { render, staticRenderFns } from "./ForgotPassword.component.vue?vue&type=template&id=43f07dd0&"
import script from "./ForgotPassword.component.vue?vue&type=script&lang=ts&"
export * from "./ForgotPassword.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports